/*       */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { loadTasksByDueDate } from 'store/actions/dashboard/dashboardActions';
import { bind } from 'app/utils/decorators/decoratorUtils';
import Widget from 'app/components/atoms/Widget/Widget';
import LinkList from 'app/containers/LandingPage/Widgets/LinkList';
import WidgetFooter from 'app/containers/LandingPage/Widgets/WidgetFooter';
import { canViewWidget, renderDueDate, widgetTypes } from '../dashboardUtils';

/**
 * Widget for displaying tasks assigned to the active user
 */
class TasksByDueDateWidget extends PureComponent {
    static propTypes = {
        loadTasksByDueDate: PropTypes.func,
        isLoading: PropTypes.bool,
        records: PropTypes.array,
        user: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);
        const canView = canViewWidget(props?.item, props?.type);
        canView && props.loadTasksByDueDate(props.user, { linkOnly: true });
    }

    @bind
    renderFooterContent() {
        const orderBy = { field: 'primary.dueDate', direction: 'asc nulls last' };
        return <WidgetFooter orderBy={orderBy} />;
    }
    @bind
    renderAdditionalInfo(props) {
        const record = { data: { primary: { dueDate: props?.primary?.dueDate } } };
        return renderDueDate(record);
    }
    @bind
    handleMenuItemClick(menu) {
        const { user, loadTasksByDueDate, menuItemClick } = this.props;
        if (menu === 'Refresh') {
            loadTasksByDueDate(user);
        } else {
            menuItemClick && menuItemClick(menu);
        }
    }
    render() {
        const { isLoading, records, item, permissions } = this.props;
        const filteredRecords = records.filter((record) => record.primary.dueDate);
        return (
            <Widget
                title={item?.widgetName || 'Tasks Due Soon'}
                subHeader='Due Date'
                content={
                    !isLoading && !records?.length ? (
                        'No Results'
                    ) : (
                        <LinkList list={filteredRecords} type='task' renderAdditionalInfo={this.renderAdditionalInfo} />
                    )
                }
                loading={isLoading}
                footerContent={this.renderFooterContent}
                menuItemClick={this.handleMenuItemClick}
                permissions={permissions}
                item={item}
                type={widgetTypes.user}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user.profile,
        isLoading: state.dashboard.tasksByDueDate.isLoading,
        records: state.dashboard.tasksByDueDate.records,
    };
};

export default connect(mapStateToProps, { loadTasksByDueDate })(TasksByDueDateWidget);
